/* eslint-disable @typescript-eslint/no-explicit-any */
import { Box, Typography } from '@mui/material';
import { ModuleConfig } from '@schamburg-web/interfaces';
import EventCard from '../../components/EventCard/EventCard';
import { getLocationDescription, getNormalizedIcon } from '../utils';

const RoadworkDisplayCard: React.FC<{
  icon: any;
  module: ModuleConfig;
}> = ({ icon, module }) => {
  const normalizedIcon = getNormalizedIcon(icon);
  const { advisoryText } = normalizedIcon || {};

  return (
    <Box sx={{ position: 'relative' }}>
      <EventCard icon={icon} module={module}>
        <Typography
          variant="body2"
          gutterBottom
          sx={{
            paddingBottom: 1,
            wordBreak: 'break-word',
            minWidth: { xs: '100px', md: 'fit-content' },
          }}
        >
          <span>{advisoryText}</span>
        </Typography>
      </EventCard>
    </Box>
  );
};

export default RoadworkDisplayCard;
